import React from "react";
import { User } from "../../../Entities/User";
import useCandidateJobApplications from "../../../Hooks/useCandidateJobApplications";
import CandidateJobApplicationsFilterMenu from "./CandidateJobApplicationsFilterMenu";
import CandidateJobApplicationsTable from "./CandidateJobApplicationsTable";

interface CandidateJobApplicationsProps {
  candidate: User;
}

const CandidateJobApplications: React.FC<CandidateJobApplicationsProps> = ({
  candidate,
}) => {
  const {
    loading,
    filters,
    pagination,
    jobApplications,
    handleClearFilter,
    handleFilter,
    handlePageChange,
  } = useCandidateJobApplications(candidate._id);
  return (
    <div className="candidate-details-tab-section candidate-job-applications">
      <CandidateJobApplicationsFilterMenu
        filters={filters}
        loading={loading}
        handleClearFilter={handleClearFilter}
        handleFilter={handleFilter}
      />
      <CandidateJobApplicationsTable
        jobApplications={jobApplications}
        loading={loading}
        pagination={pagination}
        handlePageChange={handlePageChange}
      />
    </div>
  );
};

export default CandidateJobApplications;
